import { render, staticRenderFns } from "./SwiperLazy.vue?vue&type=template&id=21afa774&"
import script from "./SwiperLazy.vue?vue&type=script&lang=js&"
export * from "./SwiperLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports